document.addEventListener("DOMContentLoaded", function () {
    // Function to update the pseudo-element width
    function updatePseudoElementWidth(patternContainer) {
        const ukContainer = patternContainer.querySelector('.uk-container');

        if (ukContainer && patternContainer) {
            const ukContainerOffset = ukContainer.getBoundingClientRect().left;
            const ukContainerPadding = 32; // Padding-left in px
            const adjustedWidth = ukContainerOffset + ukContainerPadding;

            patternContainer.style.setProperty('--pseudo-width', `${adjustedWidth}px`);
        }
    }

    // Function to reset and play the Lottie animation
    function resetAndPlayLottieAnimation(container) {
        if (container?.lottieInstance) {
            const animation = container.lottieInstance;

            console.log('Resetting and playing Lottie animation:', container.dataset.animationPath);

            // Stop and restart the animation
            animation.goToAndPlay(0, true);
        } else {
            console.warn('No Lottie instance found, reinitializing:', container);

            // Reinitialize the animation if the instance is missing
            const animationPath = container.dataset.animationPath;
            if (animationPath) {
                const animation = window.lottie.loadAnimation({
                    container: container,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true, // Start automatically
                    path: animationPath,
                });

                container.lottieInstance = animation; // Save the instance for future use
            }
        }
    }

    // Function to initialize Lottie animations
    function loadHeroLottieAnimations(callback) {
        const heroLottieContainers = document.querySelectorAll('.heroLottieContainer');
        let initializedCount = 0;

        heroLottieContainers.forEach((container) => {
            const animationPath = container.dataset.animationPath;
            if (animationPath) {
                const animation = window.lottie.loadAnimation({
                    container: container,
                    renderer: 'svg',
                    loop: false, // Play once
                    autoplay: false, // Controlled manually
                    path: animationPath,
                });

                // Store the Lottie instance for later use
                container.lottieInstance = animation;

                animation.addEventListener('DOMLoaded', () => {
                    initializedCount++;
                    if (initializedCount === heroLottieContainers.length && typeof callback === 'function') {
                        callback();
                    }
                });
            } else {
                console.warn('No animation path provided for container:', container);
            }
        });
    }

    // Function to animate the pseudo-element
    function triggerPseudoElementAnimation(patternContainer) {
        if (patternContainer) {
            updatePseudoElementWidth(patternContainer);

            patternContainer.classList.add('animate-expand');

            setTimeout(() => {
                patternContainer.classList.remove('animate-expand');
                patternContainer.classList.add('animate-retract');

                setTimeout(() => {
                    patternContainer.classList.remove('animate-retract');
                }, 1500);
            }, 4500);
        }
    }

    // Set up slide-specific animations
	function setupSlideAnimations() {
	    const swiperContainer = document.querySelector('.heroSection__slider');
	    const swiperInstance = swiperContainer?.swiper;

	    if (swiperInstance) {
	        swiperInstance.on('slideChangeTransitionEnd', function () {
	            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
	            const heroLottieContainer = activeSlide.querySelector('.heroLottieContainer');
	            const patternContainer = activeSlide.querySelector('.heroSection__sliderPattern.-desktopSlider');
	            const titleSlideElement = activeSlide.querySelector('.heroSection__titleSlideDown');

	            // Trigger pseudo-element animations
	            triggerPseudoElementAnimation(patternContainer);

	            // Reset and replay the Lottie animation for the active slide
	            resetAndPlayLottieAnimation(heroLottieContainer);

	            // Trigger slide-down animation after 4 seconds
	            if (titleSlideElement) {
	                titleSlideElement.classList.remove("slideDownActive"); // Reset animation
	                void titleSlideElement.offsetWidth; // Force reflow

	                setTimeout(() => {
	                    titleSlideElement.classList.add("slideDownActive");
	                }, 4200); // Delay of 4.2 seconds, seems to be the sweet spot with the current slide timing 
	            }
	        });

	        // Initial slide setup
	        const initialSlide = swiperInstance.slides[swiperInstance.activeIndex];
	        const heroLottieContainer = initialSlide.querySelector('.heroLottieContainer');
	        const patternContainer = initialSlide.querySelector('.heroSection__sliderPattern.-desktopSlider');
	        const initialTitleSlideElement = initialSlide.querySelector('.heroSection__titleSlideDown');

	        triggerPseudoElementAnimation(patternContainer);
	        resetAndPlayLottieAnimation(heroLottieContainer);

	        // Trigger slide-down animation for the initial slide
	        if (initialTitleSlideElement) {
	            initialTitleSlideElement.classList.remove("slideDownActive");
	            void initialTitleSlideElement.offsetWidth;

	            setTimeout(() => {
	                initialTitleSlideElement.classList.add("slideDownActive");
	            }, 4200);
	        }
	    }
	}

    // Initialize everything
    loadHeroLottieAnimations(() => {
        setupSlideAnimations(); // Set up animations after Lottie is fully loaded
    });

    window.addEventListener('resize', () => {
        const patternContainers = document.querySelectorAll('.heroSection__sliderPattern.-desktopSlider');
        patternContainers.forEach(updatePseudoElementWidth);
    });
});
